function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import Vue from 'vue';
import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, sanitizeComponent } from './utils';
import NuxtError from '../layouts/error.vue';
import NuxtLoading from './components/nuxt-loading.vue';
import _771351f8 from '../layouts/basic.vue';
import _a6a7fd36 from '../layouts/default-no-footer.vue';
import _6f6c098b from '../layouts/default.vue';
import _21ffb733 from '../layouts/homepage-layout.vue';
import _6bde3666 from '../layouts/no-navbar.vue';
import _81472920 from '../layouts/user-account-desktop.vue';
import _d842adbe from '../layouts/user-account.vue';
var layouts = {
  "_basic": sanitizeComponent(_771351f8),
  "_default-no-footer": sanitizeComponent(_a6a7fd36),
  "_default": sanitizeComponent(_6f6c098b),
  "_homepage-layout": sanitizeComponent(_21ffb733),
  "_no-navbar": sanitizeComponent(_6bde3666),
  "_user-account-desktop": sanitizeComponent(_81472920),
  "_user-account": sanitizeComponent(_d842adbe)
};
export default {
  render(h, props) {
    var loadingEl = h('NuxtLoading', {
      ref: 'loading'
    });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);
    var transitionEl = h('transition', {
      props: {
        name: 'fade',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll');
          });
        }
      }
    }, [templateEl]);
    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: '',
    nbFetching: 0
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created() {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this;
    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this;
      this.refreshOnlineStatus();
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus);
      window.addEventListener('offline', this.refreshOnlineStatus);
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
    // Add $nuxt.context
    this.context = this.$options.context;
  },
  mounted() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _this.$loading = _this.$refs.loading;
    })();
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  computed: {
    isOffline() {
      return !this.isOnline;
    },
    isFetching() {
      return this.nbFetching > 0;
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true;
        } else {
          this.isOnline = window.navigator.onLine;
        }
      }
    },
    refresh() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var pages = getMatchedComponentsInstances(_this2.$route);
        if (!pages.length) {
          return;
        }
        _this2.$loading.start();
        var promises = pages.map( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* (page) {
            var p = [];

            // Old fetch
            if (page.$options.fetch && page.$options.fetch.length) {
              p.push(promisify(page.$options.fetch, _this2.context));
            }
            if (page.$options.asyncData) {
              p.push(promisify(page.$options.asyncData, _this2.context).then(newData => {
                for (var key in newData) {
                  Vue.set(page.$data, key, newData[key]);
                }
              }));
            }

            // Wait for asyncData & old fetch to finish
            yield Promise.all(p);
            // Cleanup refs
            p = [];
            if (page.$fetch) {
              p.push(page.$fetch());
            }
            // Get all component instance to call $fetch
            for (var component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
              p.push(component.$fetch());
            }
            return Promise.all(p);
          });
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        try {
          yield Promise.all(promises);
        } catch (error) {
          _this2.$loading.fail(error);
          globalHandleError(error);
          _this2.error(error);
        }
        _this2.$loading.finish();
      })();
    },
    errorChanged() {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err);
          }
          if (this.$loading.finish) {
            this.$loading.finish();
          }
        }
        var errorLayout = (NuxtError.options || NuxtError).layout;
        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context);
        }
        this.setLayout(errorLayout);
      }
    },
    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default';
      }
      this.layoutName = layout;
      this.layout = layouts['_' + layout];
      return this.layout;
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default';
      }
      return Promise.resolve(layouts['_' + layout]);
    }
  },
  components: {
    NuxtLoading
  }
};